// extracted by mini-css-extract-plugin
module.exports =  {"propertiesContainer":"propertiesContainer___vppcq","properties":"properties___CHZzm","showMoreButton":"showMoreButton___PbdW5"};